'use client';

import { motion } from 'framer-motion';

import type { BlogPost } from '@/types/content';

import { BlogCard } from './blog-card';

interface BlogVerticalStackProps {
  posts: BlogPost[];
}

export function BlogVerticalStack({ posts }: BlogVerticalStackProps) {
  return (
    <div className="flex flex-col gap-6">
      {posts.map((post, index) => (
        <motion.div
          key={post.slug}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-50px' }}
          transition={{ duration: 0.4, delay: index * 0.1 }}
        >
          <BlogCard post={post} variant="horizontal" />
        </motion.div>
      ))}
    </div>
  );
}
